import { IPlan } from '../../model';
import React, { useContext, useMemo } from 'react';
import style from './Paywall.module.scss';
import planStyle from '../Plans/Plan.module.scss';

import PaywallPlan from './PaywallPlan';
import { IFeature } from '../../react-app-env';
import checkMark from '../../assets/images/check-mark.svg';
import cross from '../../assets/images/cross.svg';
import classNames from 'classnames';
import Plan from '../Plans/Plan';
import swiperAnimation from '../../assets/images/animation.gif';
import { TotalsType } from './Paywall';
import { AppShortContext } from '../../context/AppContext';

interface IProps {
  plans: IPlan[];
  totalPrices: TotalsType;
}

export const getEncapsulatedFeatures = (planId: string, plans: IPlan[]): string[] => {
  const plan = plans.find(p => p.plan_id === planId);
  const features = window.plans?.[planId] || [];
  return [...features, ...(
    plan?.encapsulated_plans.map((planId) => getEncapsulatedFeatures(planId, plans))?.flat(1) || []
  )].filter(Boolean);
}

const PaywallPlans = ({plans, totalPrices}: IProps) => {
  const { plans: allPlans } = useContext(AppShortContext);

  const {
    features,
    plansFeatures
  } = useMemo(() => {
    const planIds = plans.map(plan => plan.plan_id);
    const featuresCount: Record<string, number> = {};
    const plansFeatures:Record<string, (number | string)[]> = {};

    planIds.forEach(planId => {
      const planFeatures = getEncapsulatedFeatures(planId, allPlans || []) || [];
      plansFeatures[planId] = Array.from(new Set(planFeatures));
    });

    const allFeatures = (planIds
      .map(planId => {
        return plansFeatures[planId]
      })
      ?.filter(Boolean) as string[][])
      .reduce(
        (val, featureList) => {
          if (Array.isArray(featureList)) {
            featureList.forEach((feature: string) => {
              featuresCount[feature] = featuresCount[feature] ? featuresCount[feature] + 1 : 1
            })
            return val.concat(featureList?.filter(Boolean))
          }
          return val;
        }, []
      );
    // if (lastPlan?.display.sport_category === 'all' && plans.find(p => p.plan_id !== lastPlan.plan_id && p.plan_tier >= lastPlan.plan_tier)) {
    //   // If the last plan is 'all' and there are other plans with higher tier
    //   const lastPlanFeatures = window.plans?.[lastPlan.plan_id];
    //   for (const feature in featuresCount) {
    //     if (lastPlanFeatures?.includes(feature)) {
    //       featuresCount[feature] = planIds.length; // Set count to the number of plans
    //     }
    //   }
    // }

    console.log('allFeatures', allFeatures, 'featuresCount', featuresCount, 'plansFeatures', plansFeatures);

    // @ts-ignore
    const features: string[] = [...new Set(allFeatures)]?.filter(Boolean)
      ?.filter(featureId => featuresCount[featureId] < planIds.length);
    // @ts-ignore
    return {
      features: (features.map(featureId => window.features?.[featureId])?.filter(Boolean) as IFeature[])
        .sort((a, b) => {
          const res = featuresCount[a.id] - featuresCount[b.id]; // Sort - more plans - first. UPD: If it has current plan - otherwise - fewer plans - first
          if (res !== 0) return res;

          return a.priority['all'] - b.priority['all'] // Sort - less priority - first
        }),
      plansFeatures
    }
  }, [plans]);

  let tempSport = plans[0]?.display?.sport_category;

  const isSameSport = plans[1]?.display?.sport_category === tempSport;

  return <>
    <div className={classNames(planStyle.plans__wrapper, style.plans__wrapper)}>
      <div className={planStyle.plans}>
        {plans.map(plan =>
          <Plan
            plan={plan}
            wrapperClassName={style.plan_wrapper}
            className={style.plan}
            spacerClassName={style.plan_spacer}
          />
        )}
      </div>
    </div>
    <div className={style.scroll_area}>
      <table className={style.table}>
        <thead>
        <tr>
          <th>
            <div className={style.table__title}>
              Upgrade your Plan to Access
            </div>
            <img src={swiperAnimation} alt={'swipe'} className={style.table__swipe}/>

          </th>
          {plans.map(plan => {
            let sport = plan.display.sport_category;
            if (!['nfl', 'mlb', 'other'].includes(sport)) {
              sport = 'other'
            }
            return <th key={plan.plan_id}>
              <PaywallPlan
                plan={plan}
                key={plan.plan_id}
                totalPrice={totalPrices[sport as 'nfl' | 'mlb' | 'other']}
                showSportBadge={!isSameSport}
              />
            </th>
          })
          }
        </tr>
        </thead>
        <tbody>
        {features.map((feature, i, array) => <tr
          className={classNames(style.table__row, {[style.last__row]: array.length - 1 === i})}>
          <td data-preview-id={feature.previewId}>
            <div className={style.table__row__cell}>
              {feature.title}
            </div>
          </td>
          {plans.map((plan) => {
            const mainPlan = plan.isAdditional ? plan.additional : plan;
            // @ts-ignore
            if (plansFeatures?.[mainPlan.plan_id]?.includes(feature.id)) {
              return (<td>
                <div className={style.table__row__cell}>
                  <div className={style.icon}><img src={checkMark} alt={'Yes'}/></div>
                </div>
              </td>)
            }
            return (
              <td>
                <div className={style.table__row__cell}>
                  <div className={style.icon}><img src={cross} alt={'No'}/></div>
                </div>
              </td>
            )
          })}
        </tr>)}
        <tr className={style.table__row__more_options}>
          {plans.map(() => <td className={style.table__row__cell_spacer}/>)}
          <td style={{
            // @ts-ignore
            columnSpan: plans.length + 1
          }}>
            <a className={style.link} href={'/pricing'}>More Options</a>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </>
}
export default PaywallPlans;
